import apiFetch from '../../../utils/apiFetch';

// Studied Attacks (Fighter 13): the server marks a creature after a miss and consumes the mark with the next roll.
const request = async (campaignId, action, payload) => {
  if (!campaignId) return { status: 'inactive-combat' };
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/studied-attacks/${action}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok && !result.status) throw new Error(response.statusText || 'Studied Attacks could not be updated.');
  return result;
};

export const consumeStudiedAttackRoll = (campaignId, payload) => request(campaignId, 'consume', payload);
export const markStudiedOnMiss = (campaignId, payload) => request(campaignId, 'apply', payload);
